export default __webpack_public_path__ + "static/media/A0000.e644eab9.png";